//
//  SDKWorkspaceIntegrationGetGitProviders.ts
//  Supernova SDK
//
//  Created by Martin Naščák.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export const GitProviderEndpoints = {
    Organizations: "organizations",
    Projects: "projects",
    Repositories: "repositories",
    Branches: "branches",
};
